import { render, staticRenderFns } from "./AirSubcategorySelection.vue?vue&type=template&id=6896d7ca"
import script from "./AirSubcategorySelection.vue?vue&type=script&lang=js"
export * from "./AirSubcategorySelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports